<template>
  <div class="login-container">
    <el-card class="login-card">
      <template #header>
        <div v-if="windowWidth<960" class="flex flex-row-right flex-item-center" style="height:40px;">
          <el-radio-group @change="selectLang" v-model="lang" size="small">
            <el-radio-button :label="$t('lang.zh')" value="zh" />
            <el-radio-button :label="$t('lang.en')" value="en" />
          </el-radio-group>
        </div>

        <h2 style="margin-top: 10px;margin-bottom: 0px;" >{{$t('login.welcome')}}</h2>
      </template>
      <el-form :model="loginForm" class="login-form">
        <el-form-item class="margin-40-0">
          <el-input
            class="height-40"
            v-model="loginForm.username"
            :placeholder="$t('login.account')"
          ></el-input>
        </el-form-item>
        <el-form-item class="margin-40-0">
          <el-input
            class="height-40"
            v-model="loginForm.password"
            type="password"
            :placeholder="$t('login.pwd')"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="handleLogin" class="login">登录</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {token} from "@/utils/api";
import {ElCard,ElForm,ElFormItem,ElInput,ElButton,ElRadioGroup,ElRadioButton} from "element-plus";
export default {
  name: "AdminLogin",
  components:{
    ElCard,ElForm,ElFormItem,ElInput,ElButton,ElRadioGroup,ElRadioButton
  },
  data() {
    return {
      windowWidth:1280,
      lang:"zh",
      loginForm: {
        username: "",
        password: "",
      },
    };
  },
  mounted() {
    this.windowWidth = window.innerWidth
    this.lang = localStorage.getItem('lang') || "zh"
    window.addEventListener('resize', this.updateWidth)
    this.loginForm.username = localStorage.getItem('username')=='null' ? '' :  localStorage.getItem('username')
  },
  unmounted() {
    window.removeEventListener('resize', this.updateWidth)
  },
  methods: {
    selectLang(){
      this.$i18n.locale = this.lang
      localStorage.setItem('lang',this.lang);
    },
    updateWidth() {
      this.windowWidth = window.innerWidth
      console.log(this.windowWidth)
    },
    async handleLogin() {

      // 创建 FormData 对象
      const formData = new FormData();
      formData.append("username", this.loginForm.username);
      formData.append("password", this.loginForm.password);
      // 发送表单格式的请求
      token(formData).then(res=>{
        localStorage.setItem("username", this.loginForm.username);
        localStorage.setItem("token", res.data.access_token);
        localStorage.setItem("permission",JSON.stringify(res.data.permission) );
        this.$router.push("/");
      }).catch(err=>{
        console.log("Login error:", err);
        //ElMessage.error(err.response?.data?.detail || "登录失败");
      })
    },
  },
};
</script>

<style scoped>

.height-40{
  height: 40px;
}
@media screen  and (min-width: 961px) {
  ::v-deep .el-card__header{
    border-color: rgba(0, 0, 0, .07);
    color: #fff;
  }
  .login-container{
    width: 100% ;
    height: 100vh;
    background-image: url("../../public/background.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
  }
  .register-link {
    text-align: center;
    margin-top: 15px;
  }
  .login-card{
    background: rgb(64 158 255 / 26%);
    border: none;
    border-radius: 16px;
    backdrop-filter: blur(6px);
    width: 20%;
    min-width: 400px;
    height: 350px;
    position: absolute;
    right: 20%;
    top: 50vh;
    translate: 0% -50%;
    box-shadow: 0px 0px 12px 8px rgba(0, 0, 0, 0.12) !important;
  }
  .register-link a {
    color: #409eff;
    text-decoration: none;
  }
  .login{
    width: 100%;
    padding: 20px;
  }
}
@media screen  and (max-width: 960px) {
  ::v-deep .el-card__header{
    border-color: rgba(0, 0, 0, .07);
    color: #333333;
  }
  ::v-deep .el-card{
    --el-card-padding: 10px;
  }
  .margin-40-0{margin: 40px 20px}
  .login-container{
    width: 100% ;
    height: 60vh;
    margin: 0 auto;
  }
  .register-link {
    text-align: center;
    margin-top: 15px;
  }
  .login-card{
    width:80%;
    height: 85%;
    margin: 50% auto;
  }
  .register-link a {
    color: #409eff;
    text-decoration: none;
  }
  .login{
    width: 86%;
    margin-left:7%;
    padding: 20px;
  }
}

</style>
